<template>
    <div class="superior-staff-home-box">
        <div class="head-box"><navBar></navBar></div>
        <div class="content" v-if="Object.keys(form).length">
            <!-- 上上参谋banner s -->
            <div class="banner-box" v-img="{ form: form.bannerObj, key: 'img' }" :style="'background-image: url(' + form.bannerObj.img + ')'">
                <div class="container1" @click.stop>
                    <div class="img-text">
                        <div class="img-box">
                            <img class="phone-b" @click.stop v-img="{form:form.bannerObj,key:'smallImg'}" :src="form.bannerObj.smallImg" />
                        </div>
                        <div class="text-content" @click.stop>
                            <p class="name pingFang-Bold font60" v-edit="{ form: form.bannerObj, key: 'title' }">{{ form.bannerObj.title }}</p>
                            <p class="tip-text font26" v-edit="{ form: form.bannerObj, key: 'smallName' }">{{ form.bannerObj.smallName }}</p>
                            <p class="describe pingFang-Regular" v-edit="{ form: form.bannerObj, key: 'content' }">{{ form.bannerObj.content }}</p>
                            <div class="img-flex-box">
                                <div class="qr-code">
                                    <img class="qr-code-img" src="../../assets/canmo/qr_code_2.jpg" />
                                    <div class="qr-code-type">
                                        <img src="../../assets/canmo/ios.png" />
                                        iOS 版
                                    </div>
                                </div>
                                <div class="qr-code">
                                    <img class="qr-code-img" src="../../assets/canmo/qr_code_2.jpg" />
                                    <div class="qr-code-type">
                                        <img src="../../assets/canmo/android.png" />
                                        Android 版
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div></div>
                    </div>
                </div>
            </div>
            <!-- 上上参谋banner e -->
            <!-- 产品服务范围s -->
            <div class="cell-box">
                <div class="container1">
                    <div class="wow fadeInUp">
                        <p class="box-title pingFang-Heavy font40" v-edit="{ form: form.firstObj, key: 'title' }">{{ form.firstObj.title }}</p>
                        <p class="tips pingFang-Regular font24" v-edit="{ form: form.firstObj, key: 'content' }">{{ form.firstObj.content }}</p>
                    </div>
                    <div class="module-box">
                        <div class="module module-hover wow fadeInUp" v-for="(item, key) in form.firstObj.list" :key="key">
                            <div class="m-img"><img v-img="{ form: item, key: 'img' }" :src="item.img" /></div>
                            <p class="module-title font30" v-edit="{ form: item, key: 'title' }">{{ item.title }}</p>
                            <p class="text" v-edit="{ form: item, key: 'content' }">{{ item.content }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 产品服务范围e -->
            <!-- 一站式数字化开店服务平台s -->
            <div class="number-show-box" v-img="{ form: form.secoundObj, key: 'img' }" :style="'background-image: url(' + form.secoundObj.img + ')'">
                <div class="container1" @click.stop>
                    <div class="boxTitleTips wow fadeInUp">
                        <p class="box-title pingFang-Heavy font40" v-edit="{ form: form.secoundObj, key: 'title' }">{{ form.secoundObj.title }}</p>
                        <p class="tips pingFang-Regular font24" v-edit="{ form: form.secoundObj, key: 'content' }">{{ form.secoundObj.content }}</p>
                    </div>
                    <div class="number-show-content wow fadeInUp">
                        <div class="number-show-cell" v-for="(item, key) in form.secoundObj.list" :key="key">
                            <div class="text-line">
                                <div class="number text-overflow beatingNumber-box">
                                    <div class="beatingNumber" v-edit="{ form: item, key: 'name' }">{{ item.name }}</div>
                                    <div v-edit="{ form: item, key: 'unit' }">
                                        {{ item.unit }}
                                    </div>
                                    <span class="add-icon" v-edit="{ form: item, key: 'type' }">{{ item.type }}</span>
                                </div>
                            </div>
                            <p class="number-name font22" v-edit="{ form: item, key: 'content' }">{{ item.content }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 一站式数字化开店服务平台e -->
            <!-- 成为上上参谋官方合作伙伴s -->
            <div class="jh-box1">
                <div class="container1">
                    <div class="boxTitleTips wow fadeInUp">
                        <p class="box-title pingFang-Heavy font40" v-edit="{ form: form.thiredObj, key: 'title' }">{{ form.thiredObj.title }}</p>
                        <p class="tips pingFang-Regular font24" v-edit="{ form: form.thiredObj, key: 'content' }">{{ form.thiredObj.content }}</p>
                    </div>
                </div>
                <!-- 优质品牌入驻申请s -->
                <div class="img-text-flex" v-for="(item, key) in form.thiredObj.list" :key="key">
                    <div class="img-text-content">
                        <div class="img-text-div">
                            <div class="img-div public-img wow fadeInUp" v-if="key % 2 === 1"><img v-img="{ form: item, key: 'img' }" :src="item.img" /></div>
                            <div class="text-div wow fadeInUp">
                                <div class="div-content">
                                    <p class="name font40" v-edit="{ form: item, key: 'title' }">{{ item.title }}</p>
                                    <p class="describe font18" v-edit="{ form: item, key: 'content' }">{{ item.content }}</p>
                                    <router-link
                                        :to="!$store.state.token ? item.path : { path: $route.fullPath }"
                                        class="but understand-details understand-details-hover"
                                        type="primary"
                                        round
                                        v-edit="{ form: item, key: 'buttonName' }"
                                    >
                                        {{ item.buttonName }}&nbsp;
                                        <span class="arrow el-icon-d-arrow-right"></span>
                                    </router-link>
                                </div>
                            </div>
                            <div class="img-div public-img wow fadeInUp" v-if="key % 2 === 0"><img v-img="{ form: item, key: 'img' }" :src="item.img" /></div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 用户证言s -->
            <div class="carousel-show-box" v-img="{ form: form.fourthObj, key: 'img' }" :style="'background-image: url(' + form.fourthObj.img + ')'">
                <div class="container1" @click.stop>
                    <div class="boxTitleTips wow fadeInUp">
                        <p class="box-title pingFang-Heavy font40" v-edit="{ form: form.fourthObj, key: 'title' }">{{ form.fourthObj.title }}</p>
                        <p class="tips pingFang-Regular font24" v-edit="{ form: form.fourthObj, key: 'content' }">{{ form.fourthObj.content }}</p>
                    </div>
                    <div class="carousel-show-content wow fadeInUp">
                        <el-button class="control-but button-left" icon="el-icon-arrow-left" circle @click="prevClick"></el-button>
                        <el-carousel ref="carouselRef" :autoplay="false" :loop="false" arrow="never">
                            <el-carousel-item v-for="(item, key) in form.fourthObj.list" :key="key">
                                <div class="carousel-content">
                                    <div class="name-logo-box">
                                        <div class="head-portrait">
                                            <img class="head-portrait-img" v-img="{ form: item, key: 'img' }" :src="item.img" />
                                            <div class="name-introduction">
                                                <p class="name font24" v-edit="{ form: item, key: 'name' }">{{ item.name }}</p>
                                                <p class="introduction" v-edit="{ form: item, key: 'type' }">{{ item.type }}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="introduction-content textflow4 font18" v-edit="{ form: item, key: 'content' }">
                                        {{ item.content }}
                                    </div>
                                </div>
                            </el-carousel-item>
                        </el-carousel>
                        <el-button class="control-but button-right" icon="el-icon-arrow-right" circle @click="nextClick"></el-button>
                    </div>
                </div>
            </div>
            <!-- 想要了解更多信息或寻求商务合作s -->
            <div class="cooperation-box" v-img="{ form: form.fifthObj, key: 'img' }" :style="'background-image: url(' + form.fifthObj.img + ')'">
                <div class="container1" @click.stop>
                    <div class="cooperation-content">
                        <div class="cooperation-text cooperation-module">
                            <p class="cooperation-text-title font36" v-edit="{ form: form.fifthObj, key: 'title' }">{{ form.fifthObj.title }}</p>
                            <p class="cooperation-text-tips font18" v-edit="{ form: form.fifthObj, key: 'content' }">{{ form.fifthObj.content }}</p>
                        </div>
                        <div class="contact-img">
                            <img src="../../assets/cloudHome/contact.png" />
                            <img v-img="{ form: form.fifthObj, key: 'contactCode' }" style="width:100px;height:100px" :src="form.fifthObj.contactCode" />
                        </div>
                    </div>
                </div>
            </div>
            <!-- 想要了解更多信息或寻求商务合作e -->
        </div>
        <submit-form :form="form" :refComponentId="158" :id="133"></submit-form>
    </div>
</template>

<script>
import navBar from '../../components/superiorStaffNavBar.vue';
import { initWow } from '@/utils/wow';
import { pageQuery } from '../../api/index';
import submitForm from '../../components/submit-form.vue';
export default {
    name: '',
    data() {
        return {
            form: {
                // bannerObj:{
                // 	img:require('../../assets/canmo/b.png'),
                // 	smallImg:require('../../assets/canmo/phoneb.png'),
                // 	title:'上上参谋',
                // 	smallName:'300万开店者都在用的数字化产品',
                // 	content:'线下商业数据结合行业头部企业的选址模型与用户选址偏好，智能甄选开店好位置，帮助用户降低选址决策风险'
                // },
                // firstObj:{
                // 	title:'产品服务范围',
                // 	content:'以数据为驱动，多维度助力开店决策',
                // 	list:[{
                // 		img:require('../../assets/canmo/range_2.png'),
                // 		title:'选位置',
                // 		content:'线下商业数据结合行业头部企业的选址模型与用户选址偏好，智能甄选开店好位置，帮助用户降低选址决策风险'
                // 	},{
                // 		img:require('../../assets/canmo/range_1.png'),
                // 		title:'挑品牌',
                // 		content:'结合市场趋势、品牌热度的关键数据维度，帮助用户创业开店轻松找项目，开店加盟放心选品牌'
                // 	},{
                // 		img:require('../../assets/canmo/range_3.png'),
                // 		title:'找商铺',
                // 		content:'依托线下商业空间商业数据，基于用户需求匹配适合的商铺，并提供专业的经纪人服务，帮助用户省事省心找好铺'
                // 	},{
                // 		img:require('../../assets/canmo/range_4.png'),
                // 		title:'找服务',
                // 		content:'涵盖装修设计、品牌设计、工商财税、IT系统、品牌营销、法务咨询等，满足开店筹建各类需求'
                // 	}]
                // },
                // secoundObj:{
                // 	img:require('../../assets/canmo/platform_bg.png'),
                // 	title:'一站式数字化开店服务平台',
                // 	content:'助力三百万用户开店成功',
                // 	list:[{
                // 		name:'300',
                // 		unit:'万',
                // 		type:'+',
                // 		content:'开店者'
                // 	},{
                // 		name:'100',
                // 		unit:'万',
                // 		type:'+',
                // 		content:'月活开店者'
                // 	},{
                // 		name:'50',
                // 		unit:'万',
                // 		type:'+',
                // 		content:'待转商铺'
                // 	},
                // 	{
                // 		name:'1000',
                // 		unit:'',
                // 		type:'+',
                // 		content:'优选品牌加盟'
                // 	}]
                // },
                // thiredObj:{
                // 	title:'成为上上参谋官方合作伙伴',
                // 	content:'和300万中小微商家共同成长',
                // 	list:[{
                // 		img:require('../../assets/canmo/brand_apply_pic.jpg'),
                // 		title:'优质品牌入驻申请',
                // 		content:'上上参谋致力携手优质品牌，为开店用户提供真实可靠的加盟讯息，帮助开店者找到靠谱的项目',
                // 		buttonName:'了解详情',
                // 		path:'/superiorStaffBrand'
                // 	},
                // 	{
                // 		img:require('../../assets/canmo/provider_apply_pic.jpg'),
                // 		title:'开店服务商入驻申请',
                // 		content:'上上参谋面向行业打造开放生态，为开店用户提供开店筹建期的各项服务，共同助力实体开店创业。',
                // 		buttonName:'了解详情',
                // 		path:'/superiorStaffService'
                // 	}]
                // },
                // fourthObj:{
                // 	img:require('../../assets/canmo/depo_bg.jpg'),
                // 	title:'用户证言',
                // 	content:'开店找参谋，开店不踩坑',
                // 	list:[{
                // 		img:require('../../assets/img/2141950363.jpg'),
                // 		name:'渔舟沉浸式探案馆&nbsp;张玉玺',
                // 		type:'剧本杀&nbsp;/&nbsp;连锁品牌店主',
                // 		content:'我是在开店的过程中，作为一个用户了解到了上上参谋的。当时我们在选址的时候，就已经使用了这个产品。当时我就发现这个功能挺好用，其中的5A选址法，包括了竞对信息、客流情况等参考数据条件，我个人向来喜欢把工作模块数据化，上上参谋正好能满足这一块需求。再到后来我们自己做品牌了，我们也在和上上参谋寻求更多的合作机会。'
                // 	},
                // 	{
                // 		img:require('../../assets/img/rsjc.jpg'),
                // 		name:'和番丼饭&nbsp;钟老板',
                // 		type:'日式简餐&nbsp;/&nbsp;加盟店主',
                // 		content:'在使用上上参谋的过程中，我们节省了不少精力，虽然花了一部分的费用，但相较于把钱砸下去而店没有开起来要好得多，尤其是像我们这样的开店新人，帮助会更大一些。'
                // 	}]
                // },
                // fifthObj:{
                // 	title:'想要了解更多信息或寻求商务合作',
                // 	content:'您可以通过以下方式联系我们，我们将为您推荐满足需求的产品，或指派专业的销售顾问为您服务。',
                // 	img:require('../../assets/canmo/contact_blue_bg.jpg')
                // }
            },
        };
    },
    mounted() {
        pageQuery({ componentId: '158', current: 1, size: 10 }).then(res => {
            this.form = JSON.parse(res.data.data[0].context);
            this.$nextTick(() => {
                initWow();
                $('.beatingNumber').each(function() {
                    var h = Number($(this).html());
                    var t = '';
                    var n = Math.ceil(h / 20);
                    var a = true;
                    var This = $(this);
                    if ($(this).length != 0) {
                        t = $(this).offset().top;
                    }
                    This.html(0);
                    fn1();
                    $(window).scroll(function() {
                        fn1();
                    });

                    function fn1() {
                        var wT = $(window).scrollTop();
                        if (wT > t - $(window).height() + 50 && wT < t - 50 && a == true) {
                            a = false;
                            var y = 0;
                            var timer2 = setInterval(function() {
                                if (y >= h) {
                                    y = h;
                                    clearInterval(timer2);
                                }
                                This.html(y);
                                y += n;
                            }, 100);
                        }
                    }
                });
                setTimeout(() => {
                    $('.floating-img1-box').addClass('banner-img-animation');
                }, 200);
                setTimeout(() => {
                    $('.floating-img2-box').addClass('banner-img-animation');
                }, 400);
            });
        });
    },
    methods: {
        // 轮播图切换至上一页
        prevClick(e) {
            this.$refs.carouselRef.prev();
            this.setClickAnimate(e, 'control-but', 'control-but-active');
        },
        // 轮播图切换至下一页
        nextClick(e) {
            this.$refs.carouselRef.next();
            this.setClickAnimate(e, 'control-but', 'control-but-active');
        },
        performFunction() {
            let idName = [];
            for (let i = 1; i < 5; i++) {
                idName.push('beatingNumber' + i);
            }
            idName.forEach(i => {
                this.numberBeating(i);
            });
        },
        numberBeating(targetIdName = 'beatingNumber') {
            let dom = $('#' + targetIdName);
            let height = dom.parent().height();
            let text = dom.attr('data-num');
            dom.css({
                height: height + 'px'
            });
            let num = text.replace(/[^0-9]/gi, ''); //提取数字
            let len = num.length;
            for (let i = 0; i < len; i++) {
                let html = `<div class='beatingNumber-cell'>`;
                for (let t = 0; t < 10; t++) {
                    html = html + `<p>${t}</p>`;
                }
                html = html + '</div>';
                dom.append(html);
            }
            setTimeout(() => {
                let childrenDom = dom.find('.beatingNumber-cell');
                let numArr = num.split('');
                numArr.forEach((i, index) => {
                    let el = childrenDom.eq(index);
                    let elHeight = el.find('p').height();
                    el.css({
                        transform: `translateY(-${elHeight * i}px)`
                    });
                });
            }, 500);
        }
    },
    components: { navBar, submitForm }
};
</script>

<style scoped lang="less">
p {
    margin-bottom: 0;
}
@media screen and (max-width: 1024px) {
    .superior-staff-home-box {
        .head-box {
            height: auto !important;
            background-color: #fff;
        }
        .content {
            .banner-box {
                .img-text {
                    .text-content {
                        margin-left: 10px !important;
                    }
                }
            }

            .animateDom {
                .box-title {
                    padding: 0 10px;
                }

                .tips {
                    padding: 0 10px;
                }

                .button-box {
                    padding-left: 10px;
                }

                .tabs-title {
                    padding: 0 10px;
                }
            }

            .number-show-box {
                .number-show-content {
                    .number-show-cell {
                        .number {
                            padding: 0 !important;
                        }

                        .line {
                            display: none;
                        }
                    }
                }
            }

            .img-text-flex {
                .img-text-content {
                    .img-text-div {
                        .img-div {
                            width: 100% !important;
                        }

                        .text-div {
                            width: 100% !important;
                            padding: 0 10px;
                        }
                    }
                }

                .img-text-div:last-child {
                    margin-top: 15px;

                    .img-div {
                        margin-top: 15px;
                    }
                }
            }

            .carousel-show-box {
                .carousel-show-content {
                    width: 100%;
                    ::v-deep {
                        .el-carousel {
                            width: 80% !important;
                            @media @max-xs {
                                width: 100% !important;
                            }
                            .el-carousel__container {
                                height: 428px !important;
                                overflow-y: auto;
                                overflow-x: hidden;
                            }

                            .carousel-content {
                                padding: 0 20px !important;
                                @media @max-xs {
                                    padding: 0 !important ;
                                }
                            }
                        }
                    }

                    .control-but {
                        width: 40px !important;
                        height: 40px !important;
                        z-index: 1000;
                    }

                    .button-left {
                        left: 0 !important;
                    }

                    .button-right {
                        right: 0 !important;
                    }
                }
            }
        }
    }
}

@media screen and (max-width: 1540px) {
    .superior-staff-home-box {
        .content {
            .banner-box {
                .text-box {
                    justify-content: flex-start !important;
                }
            }

            .tab-show-box {
                .tab-show-content {
                    overflow-x: auto;
                    overflow-y: hidden;
                }
            }
        }
    }
}

@-webkit-keyframes moduleUp {
    0% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
    }

    50% {
        -webkit-transform: translateY(-5px);
        transform: translateY(-5px);
    }

    100% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
    }
}

.superior-staff-home-box {
    width: 100%;
    position: relative;
    .but {
        background-color: #0081ff;
        padding: 16px 40px;
        font-size: 16px;
        border: none;
        border-radius: 35px;
        @media @max-sm {
            padding: 16px 20px;
        }
    }

    .but-blank {
        background: none;
        border: thin solid #fff;
    }

    .understand-details-hover:hover {
        background-color: #016cd0;
    }

    .head-box {
        width: 100%;
        height: 80px;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 90;
        background-color: rgba(255, 255, 255, 1);
    }

    .content {
        width: 100%;
        // letter-spacing: 1px;

        .banner-box {
            width: 100%;
            // height: 800px;
            box-sizing: border-box;
            padding: 180px 0 0 0;
            // background: url('../../assets/canmo/b.png') no-repeat;
            background-size: 100% 100%;
            position: relative;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            position: relative;
            @media @max-md {
                padding: 110px 0 0 0;
            }
            .img-text {
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                @media @max-md {
                    align-items: flex-end;
                }
                @media @max-xs {
                    flex-direction: column-reverse;
                    justify-content: center;
                }
                .img-box {
                    width: 50%;
                    height: 100%;
                    position: relative;
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-end;
                    align-items: center;
                    @media @max-xs {
                        width: 70%;
                        transform: translateX(-20%);
                    }
                    .phone-b {
                        width: 100%;
                        object-fit: scale-down;
                    }
                    img {
                        width: 100%;
                    }
                    .floating-window {
                        height: 100%;
                        position: absolute;
                        top: 0;
                        left: 0;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        @media @max-lg {
                            transform: scale(0.8) translateX(-10%);
                        }
                        .floating-img-box {
                            opacity: 0;
                        }

                        .floating-img1-box {
                            transform-style: preserve-3d;
                            transform: perspective(25px);

                            .img-style1 {
                                transform: translate3d(25%, 30%, 0px);
                            }
                        }

                        .floating-img2-box {
                            transform-style: preserve-3d;
                            transform: perspective(25px);

                            .img-style2 {
                                transform: translate3d(30%, 10%, 0px);
                            }
                        }
                    }
                }

                .text-content {
                    width: 50%;
                    color: #fff;
                    margin-left: 85px;
                    @media @max-md {
                        padding: 0 0 60px 0;
                    }
                    @media @max-xs {
                        width: 100%;
                        padding: 0 0 30px 0;
                    }
                    .tip-text {
                        // font-size: 26px;
                        margin-top: 0px;
                    }

                    .describe {
                        // font-size: 16px;
                        margin-top: 30px;
                        @media @max-xs {
                            margin-top: 10px;
                        }
                    }

                    .img-flex-box {
                        display: flex;
                        align-items: center;
                        margin-top: 50px;
                        @media @max-xs {
                            margin-top: 20px;
                        }
                        .qr-code {
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            margin-left: 20px;

                            .qr-code-img {
                                border-radius: 8px;
                            }

                            .qr-code-type {
                                display: flex;
                                align-items: center;
                                // font-size: 15px;
                                color: #000;
                                margin-top: 7px;

                                img {
                                    width: 20px;
                                    height: auto;
                                    object-fit: scale-down;
                                    margin-right: 12px;
                                }
                            }
                        }

                        .qr-code:first-child {
                            margin-left: 0;
                        }
                    }
                }
            }
        }

        .banner-img-animation {
            animation: fadeInUp 1s ease forwards;
        }

        .cell-box {
            width: 100%;
            padding: 125px 0 112px 0;
            background-color: #f8f9fd;
            box-sizing: border-box;
            @media @max-xs {
                padding: 60px 0;
            }
            .container1 {
                max-width: 1600px;
            }
            .box-title {
                color: #000;
                margin-bottom: 4px;
                text-align: center;
            }

            .tips {
                color: #65697f;
                margin-bottom: 35px;
                text-align: center;
            }

            .module-box {
                width: 100%;
                display: flex;
                justify-content: center;
                flex-wrap: wrap;

                .module {
                    width: calc((100% - 60px) / 4);
                    box-sizing: border-box;
                    // display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    border-radius: 8px;
                    flex-shrink: 0;
                    background-color: #fff;
                    margin-right: 20px;
                    padding: 33px 30px 75px 30px;
                    box-shadow: 0 0px 16px 0 rgba(204, 204, 204, 0.4);
                    @media @max-sm {
                        width: calc((100% - 20px) / 2);
                        margin-top: 20px;
                    }
                    @media @max-xs {
                        width: 100%;
                        margin-right: 0;
                    }
                    .m-img {
                        width: 100%;
                        height: 210px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin-bottom: 5px;

                        img {
                            width: auto;
                            height: 210px;
                            object-fit: scale-down;
                            @media @max-lg {
                                height: 150px;
                            }
                        }
                    }

                    .module-title {
                        color: #000;
                        margin-bottom: 10px;
                        font-family: 'PingFang-Heavy' !important;
                        text-align: center;
                    }

                    .text {
                        // height: 62px;
                        color: #65697f;
                        word-break: break-all;
                        text-align: left;
                    }

                    .but-box {
                        height: 50px;
                        margin-top: 10px;

                        .but {
                            display: none;
                            margin: 0;
                        }
                    }
                    &:nth-child(even) {
                        @media @max-sm {
                            margin-right: 0;
                        }
                    }
                }

                .module:last-child {
                    margin-right: 0;
                }

                .module-hover:hover {
                    background-color: #ffffff;
                }

                .module-hover:hover .m-img {
                    animation: moduleUp 2s ease forwards;
                }

                .module-hover:hover .module-title {
                    color: #0081ff;
                }

                .module-hover:hover .but-box .but {
                    display: block;
                }
            }
        }

        .number-show-box {
            width: 100%;
            // background: url('../../assets/canmo/platform_bg.png') no-repeat;
            // background-size: 100% 100%;
            background-size: cover;
            background-position: center;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding: 110px 0 100px 0;
            animation-play-state: paused;
            opacity: 1 !important;
            transform: translateY(0) !important;
            @media @max-xs {
                padding: 60px 0;
            }

            .box-title {
                color: #fff;
                // font-size: 40px;
                margin-bottom: 4px;
            }

            .tips {
                color: #fff;
                // font-size: 24px;
                margin-bottom: 35px;
                @media @max-xs {
                    margin-bottom: 0;
                }
            }

            .number-show-content {
                display: flex;
                flex-wrap: wrap;

                // justify-content: center;
                // align-items: center;

                .number-show-cell {
                    width: 25%;
                    box-sizing: border-box;
                    color: #fff;
                    position: relative;

                    @media @max-md {
                        width: 50%;
                        margin-top: 40px;
                    }

                    &::before {
                        content: '';
                        position: absolute;
                        right: 0;
                        top: 50%;
                        transform: translateY(-50%);
                        width: 1px;
                        height: 100%;
                        background-color: #9acfff;
                    }
                    &:nth-child(even) {
                        &::before {
                            @media @max-sm {
                                display: none;
                            }
                        }
                    }
                    &:last-child {
                        &::before {
                            display: none;
                        }
                    }
                    .text-line {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        padding: 0 20px;
                        .number {
                            width: 100%;
                            box-sizing: border-box;
                            font-size: 80px;
                            line-height: 112px;
                            display: flex;
                            justify-content: center;
                            align-items: baseline;
                            // padding: 0 60px;
                            font-family: 'PingFang-Heavy' !important;
                            // .beatingNumber-cell{
                            // 	margin-bottom:0 !important;
                            // }
                            @media @max-lg {
                                font-size: 60px;
                                line-height: 80px;
                            }
                            @media @max-md {
                                font-size: 50px;
                                line-height: 70px;
                            }
                            @media @max-xs {
                                font-size: 35px;
                                line-height: 50px;
                            }
                            .add-icon {
                                font-size: 55px;
                                @media @max-md {
                                    font-size: 40px;
                                }
                                @media @max-xs {
                                    font-size: 20px;
                                }
                            }
                        }

                        .line {
                            width: 1px;
                            height: 80px;
                            background-color: #9acfff;
                        }
                    }

                    .number-name {
                        width: 100%;
                        margin-top: 10px;
                        text-align: center;
                        box-sizing: border-box;
                        font-size: 22px;
                        transform: translateY(-10px);
                    }
                }

                .number-show-cell:first-child {
                    .text-line {
                        .number {
                            padding-left: 0;
                        }
                    }
                }
                .number-show-cell:last-child {
                    .text-line {
                        .number {
                            padding-right: 0;
                        }
                    }
                }
            }
        }

        .jh-box1 {
            padding: 190px 0 120px 0;
            background: url('../../assets/images/output.png') repeat top left;
            @media @max-md {
                padding: 60px 0;
            }
            .img-text-flex {
                width: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                margin-top: 150px;
                @media @max-md {
                    margin-top: 60px;
                }
                &:nth-child(2) {
                    margin-top: 80px;
                    @media @max-md {
                        margin-top: 40px;
                    }
                }
                &:nth-child(odd) {
                    .img-text-div {
                        @media @max-sm {
                            flex-direction: column-reverse;
                        }
                    }
                }

                .box-title {
                    color: #000;
                    margin-bottom: 4px;
                }

                .tips {
                    color: #5a6779;
                    margin-bottom: 78px;
                    @media @max-md {
                        margin-bottom: 40px;
                    }
                }

                .img-text-content {
                    width: 100%;

                    .img-text-div {
                        width: 100%;
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: space-between;
                        align-items: center;

                        .img-div {
                            width: 50%;
                            @media @max-md {
                                width: 50% !important;
                                // margin: 0 auto;
                            }
                            @media @max-sm {
                                width: 90% !important;
                                margin: 0 auto;
                            }
                            &::before {
                                padding-top: 72.91%;
                            }
                            img {
                                // width: 100%;
                                // height: auto;
                                // object-fit: scale-down;
                            }
                        }

                        .text-div {
                            width: 50%;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;
                            box-sizing: border-box;
                            @media @max-md {
                                width: 50% !important;
                                padding: 0 10%;
                            }
                            @media @max-sm {
                                width: 90% !important;
                                margin: 40px auto 0;
                                padding: 0;
                                align-items: flex-start;
                            }
                            .div-content {
                                .name {
                                    color: #0081ff;
                                    margin-bottom: 32px;
                                    @media @max-sm {
                                        margin-bottom: 10px;
                                    }
                                }

                                .describe {
                                    max-width: 470px;
                                    color: #65697f;
                                    margin-bottom: 90px;
                                    @media @max-md {
                                        margin-bottom: 40px;
                                    }
                                }

                                .but {
                                    color: #fff;
                                }
                            }
                        }
                    }
                }
            }
        }

        .carousel-show-box {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            // background: url('../../assets/canmo/depo_bg.jpg') no-repeat;
            background-size: cover;
            padding-top: 120px;
            @media @max-sm {
                padding-top: 60px;
            }
            .box-title {
                color: #fff;
                margin-bottom: 4px;
            }

            .tips {
                color: #fff;
                margin-bottom: 60px;
            }

            .carousel-show-content {
                display: flex;
                justify-content: center;
                align-items: center;
                padding-bottom: 115px;
                position: relative;
                @media @max-sm {
                    padding-bottom: 60px;
                }
                ::v-deep {
                    .el-carousel {
                        width: 78.57%;

                        .el-carousel__container {
                            height: 428px;
                            border-radius: 8px;
                            background-color: #fff;
                        }
                    }
                }

                .control-but {
                    width: 60px;
                    height: 60px;
                    position: absolute;
                    top: calc(50% - 86px);
                    @media @max-sm {
                        top: unset;
                        bottom: 75px;
                    }
                }

                .control-but-active {
                    background-color: #eb5405;
                    color: #fff !important;
                    border: none;
                }

                .button-left {
                    left: 2%;
                    @media @max-sm {
                        left: 30% !important;
                    }
                }
                .button-right {
                    right: 2%;
                    @media @max-sm {
                        right: 30% !important;
                    }
                }

                .carousel-content {
                    width: 100%;
                    border-radius: 8px;
                    box-sizing: border-box;
                    margin-top: 60px;
                    padding-bottom: 80px;
                    .name-logo-box {
                        width: 100%;
                        padding: 0px 76px 0 76px;
                        box-sizing: border-box;
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: space-between;
                        align-items: center;
                        @media @max-sm {
                            padding: 0 20px 0 20px;
                        }
                        @media @max-xs {
                            padding: 0 10px 0 10px;
                        }
                        .head-portrait {
                            display: flex;
                            justify-content: space-between;
                            align-items: center;

                            .head-portrait-img {
                                width: 100px;
                                height: 100px;
                                border-radius: 50%;
                                object-fit: cover;
                            }

                            .name-introduction {
                                margin-left: 15px;

                                .name {
                                    // font-size: 24px;
                                    color: #121826;
                                }

                                .introduction {
                                    // font-size: 16px;
                                    color: #999999;
                                }
                            }
                        }
                    }

                    .introduction-content {
                        width: 100%;
                        // min-height: 267px;
                        height: calc(7.2em + 63px);
                        padding: 63px 109px 0 116px;
                        box-sizing: border-box;
                        text-align: left;
                        font-size: 18px;
                        color: #7d89a1;
                        letter-spacing: 0px;
                        line-height: 1.8em;
                        word-break: break-all;
                        background-image: url('../../assets/cloudProduct/qu_1.png'), url('../../assets/cloudProduct/qu_2.png');
                        background-repeat: no-repeat, no-repeat;
                        background-position: 82px 34px, 91.5% 100%;
                        @media @max-sm {
                            height: calc(9em + 20px);
                            padding: 20px 20px 0 20px;
                            background-image: unset;
                        }
                        @media @max-xs {
                            padding: 20px 10px 0 10px;
                        }
                    }
                }
            }
        }

        .cooperation-box {
            width: 100%;
            height: auto;
            // background-image: url('../../assets/canmo/contact_blue_bg.jpg');
            background-repeat: no-repeat;
            background-size: cover;
            padding-top: 28px;
            animation-play-state: paused;
            opacity: 1 !important;
            transform: translateY(0) !important;
            @media @max-sm {
                padding-top: 60px;
            }
            .cooperation-content {
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                align-items: center;
                align-content: flex-start;

                .cooperation-text {
                    max-width: 550px;
                    color: #fff;
                    padding-left: 10px;
                    letter-spacing: 0;
                    @media @max-md {
                        max-width: 450px;
                    }
                    @media @max-sm {
                        max-width: 100%;
                        width: 100%;
                        text-align: center;
                        padding-left: 0;
                    }
                    .cooperation-text-title {
                        // font-size: 35px;
                        margin-bottom: 4px;
                        font-family: 'PingFang-Heavy' !important;
                        // transform: translateY(-25px);
                    }
                    .cooperation-text-tips {
                        // font-size: 18px;
                        // transform: translateY(-25px);
                    }
                }

                .contact-img {
                    position: relative;
                    margin-right: 120px;

                    @media @max-md {
                        margin-right: 60px;
                    }
                    @media @max-sm {
                        margin-top: 60px;
                        margin-right: 0;
                        margin: 60px auto 0;
                    }
                    img {
                        width: 260px;
                        height: auto;
                        object-fit: scale-down;
                        &:nth-child(2) {
                            position: absolute;
                            left: 82px;
                            width: 100px;
                            top: 84px;
                        }
                    }
                }
            }
        }
    }
}

// 公共图片
.public-img {
    display: block;
    position: relative;
    z-index: 1;
    overflow: hidden;
    &::before {
        content: '';
        display: block;
        position: relative;
        z-index: 0;
        padding-top: 100%;
    }
    & > img {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: all 0.5s;
    }
}

.textflow4 {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    word-break: break-all;
}
</style>
